var map = {
	"./file-csv.svg": "2OF4",
	"./file-doc.svg": "mJq2",
	"./file-folder.svg": "30bm",
	"./file-image.svg": "YHo5",
	"./file-music.svg": "lY1R",
	"./file-pdf.svg": "UV3t",
	"./file-ppt.svg": "uMg1",
	"./file-txt.svg": "HtK/",
	"./file-xls.svg": "8VDL",
	"./file-zip.svg": "/HgX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FUbA";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/file\-.*\.svg$
// module id = FUbA
// module chunks = 46